import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { UICard, UIGrid } from "../../_app/components";
import { useFeedbackAlerts } from "../../_app/hooks";
import Main from "../../_app/layouts/Main";
import { createStylesheet } from "../../_app/utils/styles";
import { useSingleAsset, useUpdateBillLimitPrefs } from "../../asset/hooks";
import { Feature } from "../../feature/types";
import BillLimitAlertsTabBar from "../components/BillLimitAlerts/BillLimitAlertsTabBar";
import BillLimitAlertsUpdateForm from "../components/BillLimitAlerts/BillLimitAlertsUpdateForm";

export const BillLimitAlertsCliDetail = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { data: asset } = useSingleAsset(id ?? "");
  const queryClient = useQueryClient();
  const { setFeedbackAlertSuccess } = useFeedbackAlerts();

  const updateBillLimitPrefs = useUpdateBillLimitPrefs({
    onSuccess: (response: string) => {
      setFeedbackAlertSuccess(response);
      navigate("/bill-limit-alerts-cli");
      queryClient.invalidateQueries({
        queryKey: ["bill-limit-prefs", id],
      });
    },
  });

  const updatePrefs = (sms: boolean, email: boolean, smsValue?: string, emailValue?: string) => {
    updateBillLimitPrefs.mutate({
      assetIds: [id ?? ""],
      operations: [
        {
          sendSms: sms,
          sendEmail: email,
          notifyMobileNumber: smsValue,
          notifyEmailAddress: emailValue,
        },
      ],
    });
  };

  return (
    <Main
      title="Bill Limit Alerts"
      data-cy="bill-limit-alerts-cli-page"
      needSelectedAccount
      titleProps={{ className: classes.title }}
      feature={Feature.BillLimitAlerts}
    >
      <BillLimitAlertsTabBar selectedTab="bill-limit-alerts-cli">
        <UICard>
          <UIGrid>
            <BillLimitAlertsUpdateForm assetId={id} cli={asset?.cli} callback={updatePrefs} />
          </UIGrid>
        </UICard>
      </BillLimitAlertsTabBar>
    </Main>
  );
};

const useStyles = createStylesheet(() => ({
  title: {
    marginBottom: 10,
  },
}));

export default BillLimitAlertsCliDetail;
